import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { 
  Home as HomeIcon, 
  Dashboard as DashboardIcon, 
  People as PeopleIcon, 
  CameraAlt as CameraIcon,
  AccountCircle as ProfileIcon,
  Notifications as NotificationsIcon,
  Business as BusinessIcon,
  Policy as PolicyIcon,
  ReceiptLong as ReceiptLongIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';

const MobileNavigation = ({ userType = 'guest' }) => {
  const location = useLocation();
  const history = useHistory();

  const getNavItems = () => {
    switch (userType) {
      case 'admin':
        return [
          { path: '/dashboard', label: 'Dashboard', icon: DashboardIcon },
          { path: '/companies', label: 'Companies', icon: BusinessIcon },
          { path: '/verification-attempts', label: 'Attempts', icon: ReceiptLongIcon },
          { path: '/verification-rules', label: 'Rules', icon: PolicyIcon },
          { path: '/profile', label: 'Profile', icon: ProfileIcon }
        ];
      case 'company':
        return [
          { path: '/company/dashboard', label: 'Dashboard', icon: DashboardIcon },
          { path: '/company/members', label: 'Members', icon: PeopleIcon },
          { path: '/company/verification-attempts', label: 'Attempts', icon: CameraIcon },
          { path: '/company/analytics', label: 'Analytics', icon: NotificationsIcon },
          { path: '/company/profile', label: 'Profile', icon: ProfileIcon }
        ];
      default:
        return [
          { path: '/', label: 'Home', icon: HomeIcon },
          { path: '/member-verification', label: 'Verify', icon: CameraIcon },
          { path: '/login', label: 'Login', icon: ProfileIcon }
        ];
    }
  };

  const navItems = getNavItems();

  const handleNavClick = (path) => {
    history.push(path);
  };

  return (
    <nav className="mobile-nav">
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-around', 
        alignItems: 'center',
        padding: '8px 0',
        backgroundColor: '#1a1d26',
        borderTop: '1px solid #333'
      }}>
        {navItems.map((item) => {
          const IconComponent = item.icon;
          const isActive = location.pathname === item.path || 
                          location.pathname.startsWith(item.path + '/');
          
          return (
            <button
              key={item.path}
              onClick={() => handleNavClick(item.path)}
              className={`nav-item ${isActive ? 'active' : ''}`}
              style={{
                background: 'none',
                border: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '8px',
                color: isActive ? '#1976d2' : '#666',
                textDecoration: 'none',
                fontSize: '0.75rem',
                cursor: 'pointer',
                minWidth: '44px',
                minHeight: '44px',
                borderRadius: '8px',
                transition: 'all 0.2s ease',
                backgroundColor: isActive ? 'rgba(25, 118, 210, 0.1)' : 'transparent'
              }}
            >
              <IconComponent 
                className="nav-icon" 
                style={{ 
                  fontSize: '1.5rem', 
                  marginBottom: '4px',
                  color: isActive ? '#1976d2' : '#666'
                }}
              />
              <span style={{ 
                color: isActive ? '#1976d2' : '#666',
                fontWeight: isActive ? '600' : '400'
              }}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNavigation; 